export default "__VITE_ASSET__BoCVVCOe__"